export default __webpack_public_path__ + "static/media/5.978a79fa.png";